var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvertisers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.69 4.04835C18.66 4.72835 15.86 5.49835 12 5.49835C8.11 5.49835 5.05 4.65835 3.31 4.06835C2.67 3.84835 2 4.32835 2 5.01835V18.9984C2 19.6784 2.66 20.1684 3.31 19.9484C5.36 19.2584 8.1 18.4984 12 18.4984C15.87 18.4984 18.66 19.2584 20.69 19.9484C21.34 20.1584 22 19.6784 22 18.9984V4.99835C22 4.31835 21.34 3.83835 20.69 4.04835ZM17.28 15.2584C15.62 15.0984 13.84 14.9984 12 14.9984C10.13 14.9984 8.37 15.0984 6.72 15.2684C6.27 15.3084 6 14.7884 6.29 14.4484L8.79 11.4484C8.99 11.2084 9.36 11.2084 9.56 11.4484L11.18 13.3884L13.62 10.4584C13.82 10.2184 14.19 10.2184 14.39 10.4584L17.71 14.4484C17.99 14.7884 17.72 15.3084 17.28 15.2584Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisers);
export default __webpack_public_path__ + "static/media/Advertisers.4c6637eba33dcf180bc98b4e3ce9d4a0.svg";
export { ForwardRef as ReactComponent };